import { Box, Group, Text } from '@mantine/core'
import type { CSSProperties } from 'react'

import type { PredictionEvent } from '@/services/prediction/types'

import liveLabelStyles from './liveLabelStyles.module.css'

interface CompactLiveLabelProps {
  event: PredictionEvent
}

/**
 * Port of cdc-web `Compact/_shared/CompactLiveLabel.tsx`（1:1）。
 * LIVE 徽标：8px 脉动红点 + "LIVE"（danger 色）+ 可选的 "period • 剩余时间" 尾巴。
 */
export function CompactLiveLabel({ event }: Readonly<CompactLiveLabelProps>) {
  const indicator = event.live_coverage?.progress_indicator
  const period = indicator?.find(item => item.name === 'current_period')?.value
  const remainingTime = indicator?.find(item => item.name === 'remaining_time')?.value
  const gameInfo = [period, remainingTime].filter(Boolean).join(' • ')

  return (
    <Group gap="2xs" align="center" wrap="nowrap" aria-label="Event is live">
      <Group gap="3xs" align="center" wrap="nowrap">
        <Box
          component="span"
          className={liveLabelStyles.pulsingDot}
          style={
            { '--dot-size': '8px', background: 'var(--bg-status-danger-bold)' } as CSSProperties
          }
          aria-hidden="true"
        />
        <Text component="span" variant="subtitle" c="var(--content-danger-bold)">
          LIVE
        </Text>
      </Group>
      {gameInfo && (
        <Text component="span" variant="subtitle" c="var(--content-secondary)">
          {gameInfo}
        </Text>
      )}
    </Group>
  )
}
